import { createInfiniteSearchSelect } from '../common/form';
import { useInfiniteSearchUsersQuery } from './query/useInfiniteSearchUsersQuery';

export const FormUserAutoComplete = createInfiniteSearchSelect(
  useInfiniteSearchUsersQuery
);
